import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from '../adapter-registry';
import { LinkedServiceAdapter } from './linkedservice.adapter';
import { Model } from '../../backendmodel';
import { InvokeCopyJobLinkedService } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(InvokeCopyJobLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {},
            parameters: '*'
        }
    }
})
export class InvokeCopyJobLinkedServiceAdapter extends LinkedServiceAdapter<InvokeCopyJobLinkedService> {

    protected modelConstructor(): new () => InvokeCopyJobLinkedService {
        return InvokeCopyJobLinkedService;
    }

    protected model(): IModel {
        return InvokeCopyJobLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(_linkedService: InvokeCopyJobLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        return linkedServiceResource;
    }
    
    protected async propertiesToModelAsync(_linkedServiceResource: Model.LinkedServiceResource, linkedService: InvokeCopyJobLinkedService): Promise<InvokeCopyJobLinkedService> {
        return linkedService;
    }
}